// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React, { useMemo } from 'react';
import { Box, useTheme } from '@mui/system';
import { CircularProgress } from '@mui/material';
import { PDFDownloadLink } from '@react-pdf/renderer';
import downloadIcon from 'Assets/download-icon.png';
import PDF from 'Features/order/PDF';
import stylesDef from './styles';

interface PDFDownloadProps {
  pdfData: IPdf;
  projectId: string;
}

const PDFDownload = React.memo(({ pdfData, projectId }: PDFDownloadProps) => {
  const theme = useTheme();
  const styles = stylesDef(theme);

  const PDFDoc = useMemo(() => <PDF data={pdfData} />, [pdfData]);

  return (
    <PDFDownloadLink
      document={PDFDoc}
      fileName={`${pdfData?.projectName}_invoice.pdf`}
    >
      {({ url }) => (url ? (
        <Box
          sx={styles.downloadText}
          onClick={() => {
            window?.pendo?.track('Invoice downloaded', { projectId });
          }}
        >
          <img src={downloadIcon} alt="download" />
        </Box>
      ) : (
        <CircularProgress size={24} sx={styles.buttonProgress} />
      ))}
    </PDFDownloadLink>
  );
});

export default PDFDownload;
